module.exports = __webpack_public_path__ + "static/assets/d4c76faf58b94e84464a1d4de6702387.png";